import './core/device.js';
import './core/adaptive.js';

import './modules/scroll.js';     // lenis FIRST (dependency)
import './modules/menu.js';       // depends on lenis

import './modules/cursor.js';
import './modules/search.js';
import './modules/forms.js';
import './modules/tabs.js';
import './modules/accordion.js';
import './modules/spoilers.js';
import './modules/lazy.js';
import './modules/popup.js';
import './modules/animations.js';
import './modules/ui.js';
import './modules/copytext.js';
